import React from "react";
import { Subscribe } from "unstated";
import ModalContainer from "../../state/ModalContainer";

export default () => (
  <Subscribe to={[ModalContainer]}>
    {(modal: any) => {
      const { component: Component, props } = modal.state;

      return Component ? (
        <Component {...props} hideModal={modal.hideModal} />
      ) : null;
    }}
  </Subscribe>
);
